<ftr-page [pageStyle]="pageStyle">
  <article class="courtroom-display-component">
    <div class="card card--borderless card--shadowless password-card">
      <header class="display__header">
        <h1 class="config-card__title">Courtroom Display</h1>
        <p class="config-card__subtitle">
          For The Record provides access to the court record, securely and in real-time.
        </p>
      </header>
    </div>
  </article>
</ftr-page>
